import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../_services/user.service';
import { RestError } from '../_models/resterror';

@Component({
  moduleId: module.id,
  templateUrl: 'passwordreset.component.html',
  styleUrls: ['passwordreset.component.css']
})

export class PasswordResetComponent implements OnInit {
  model: any = {};
  error = false;
  errorMessage : string;
  success = false;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService
  ){}

  ngOnInit() {

    this.model.username = this.route.snapshot.params['username'] || '';
    this.model.token = this.route.snapshot.params['token'] || '';

  }

  onError(err) {
    this.loading = false;
    this.success = false;
    this.error = true;
    var restError = <RestError> err.json();
    this.errorMessage = restError.error;
  }


  passwordReset() {
    this.loading = true;

    this.userService.passwordReset(this.model.username, this.model.password, this.model.token)
      .then(data => {
        this.loading = false;
        this.success = true;
      })
    .catch(err => {
        this.onError(err);
    });
  }


  sendPasswordReset() {
    this.loading = true;

    this.userService.sendPasswordReset(this.model.username)
      .then(data => {
        this.loading = false;
        this.success = true;

      }, this.onError)
      .catch(this.onError.bind(this));
  }

}



// WEBPACK FOOTER //
// ./src/app/passwordreset/passwordreset.component.ts